import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  areaCode: string;
  onClick: (e: any) => void;
}

export default function ResetButton({ areaCode, onClick }: IProps) {
  return (
    <button
      type="button"
      aria-label="필터 초기화"
      className={cx('ResetButton')}
      data-event-nlog="click"
      data-event-area-code={`${areaCode}.filterrefresh`}
      onClick={onClick}
    />
  );
}
